import { HTTP_METHODS } from '@studio/constants/axios';
import { CENTRAL_API_V3 } from '@studio/constants/env-variables';
import type { Buckets } from '@studio/types';

export const root = {
  [HTTP_METHODS.GET]: {
    url: `${CENTRAL_API_V3}/customers/@customerId/regions/@regionId/vod/buckets`,
    params: {} as { regionId: string },
    response: {} as Buckets.Get.Buckets,
    method: HTTP_METHODS.GET,
  },
  [HTTP_METHODS.POST]: {
    url: `${CENTRAL_API_V3}/customers/@customerId/regions/@regionId/vod/buckets`,
    params: {} as { regionId: string },
    method: HTTP_METHODS.POST,
  },
};

export const id = {};
